import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, ChevronRight, X } from 'lucide-react';
import './style/CreateExamFromSyllabus.css';

const syllabusFiles = [
  { id: 1, title: 'Mathematics Syllabus', filename: 'math_syllabus.pdf' },
  { id: 2, title: 'Physics Syllabus', filename: 'physics_syllabus.pdf' },
  { id: 3, title: 'Chemistry Syllabus', filename: 'chemistry_syllabus.pdf' },
  { id: 4, title: 'Biology Syllabus', filename: 'biology_syllabus.pdf' },
  { id: 5, title: 'Computer Science Syllabus', filename: 'cs_syllabus.pdf' },
  { id: 6, title: 'English Literature Syllabus', filename: 'english_syllabus.pdf' },
  { id: 7, title: 'History Syllabus', filename: 'history_syllabus.pdf' },
  { id: 8, title: 'Geography Syllabus', filename: 'geography_syllabus.pdf' },
];

export default function CreateExamFromSyllabus() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showPdfPreview, setShowPdfPreview] = useState(false);
  const navigate = useNavigate();

  const handleFileSelect = (file) => {
    setSelectedFile(file);
    if (file.id === 1) { // Assuming the first file (Mathematics Syllabus) is the one we want to preview
      setShowPdfPreview(true);
    } else {
      setShowPdfPreview(false);
    }
  };

  const handleNext = () => {
    if (selectedFile) {
      navigate('/exams/create-from-syllabus/pdf-list');
    }
  };

  const closePdfPreview = () => {
    setShowPdfPreview(false);
  };

  return (
    <div className="unique15-create-exam-container bg-gradient-to-br from-blue-100 to-purple-100">
      <h1 className="unique15-title">Create Exam from Syllabus</h1>
      <p className="unique15-subtitle">Select a syllabus file to create an exam</p>
      
      <div className="unique15-files-grid">
        {syllabusFiles.map((file) => (
          <div 
            key={file.id} 
            className={`unique15-file-card ${selectedFile === file ? 'unique15-selected' : ''}`}
            onClick={() => handleFileSelect(file)}
          >
            <div className="unique15-file-icon">
              <FileText size={36} />
            </div>
            <h3 className="unique15-file-title">{file.title}</h3>
            <p className="unique15-file-name">{file.filename}</p>
          </div>
        ))}
      </div>

      {showPdfPreview && (
        <div className="unique15-pdf-preview-overlay">
          <div className="unique15-pdf-preview-container">
            <button className="unique15-close-preview" onClick={closePdfPreview}>
              <X size={24} />
            </button>
            <iframe
              src={`/pdfs/reactjs_tutorial.pdf`}
              title="PDF Preview"
              width="100%"
              height="100%"
              className="unique15-pdf-iframe"
            />
          </div>
        </div>
      )}

      <div className="unique15-navigation">
        <button className="unique15-nav-button" disabled={!selectedFile} onClick={handleNext}>
          Next
          <ChevronRight size={24} />
        </button>
      </div>
    </div>
  );
}